import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon } from 'lucide-react';
import { business } from '../data/site';
type CallBandProps = {
  heading: string;
  copy: string;
  secondary?: {
    label: string;
    to: string;
  };
};
export function CallBand({
  heading,
  copy,
  secondary
}: CallBandProps) {
  return <section className="w-full bg-ink py-16 text-white lg:py-20" data-id="element-133" data-mp="ami052khcdtk">
      <div className="mx-auto flex max-w-shell flex-col gap-8 px-5 lg:flex-row lg:items-center lg:justify-between lg:px-8" data-id="element-134" data-mp="ycubknexosow">
        <div data-id="element-135" data-mp="12epcvrwv762o">
          <h2 className="max-w-[560px] font-display text-[28px] font-extrabold leading-[1.1] tracking-[-0.02em] sm:text-[34px]" data-id="element-136" data-mp="12dede4agckhd">
            {heading}
          </h2>
          <p className="mt-4 max-w-[520px] text-[16px] leading-relaxed text-chalk/70" data-id="element-137" data-mp="tlvxluhf46ot">
            {copy}
          </p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center lg:shrink-0" data-id="element-138" data-mp="1haosroq7uaid">
          <a href={business.phoneHref} className="inline-flex items-center justify-center gap-3 whitespace-nowrap rounded-md bg-brand px-7 py-4 font-display text-lg font-bold text-white transition-colors duration-150 ease-out hover:bg-brand-light" data-id="element-139" data-mp="1m2onn2rfid83">
            <PhoneIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-140" data-mp="148fo8o0tbbda" />
            Call {business.phone}
          </a>
          {secondary && <Link to={secondary.to} className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-white/25 px-7 py-4 text-base font-semibold text-white transition-colors duration-150 ease-out hover:border-white/60" data-id="element-141" data-mp="zfuvzqxk16bv">
              {secondary.label}
            </Link>}
        </div>
      </div>
    </section>;
}